import { QueryOperation, SearchQuery } from "../code/search-query/search-query";
import {
  buildSearchQuery,
  comboboxValue,
  QueryFieldMapping,
} from "../code/search-query/query-mapper";
import { DataColumn } from "../controls/Data.default";
import { InputObject } from "../controls/default";

export interface CompanyPoliciesViewForm {
  readonly name: string;
  readonly code: string;
  readonly pdfUrl: string;
  readonly company?: InputObject;
}

export const companyPoliciesViewColumns: DataColumn[] = [
  {
    title: "Name",
    key: "name",
    width: 192,
    sort: true,
    defaultSort: "asc",
    fixed: "left",
  },
  {
    title: "Code",
    key: "code",
    width: 192,
    sort: true,
  },
  {
    // Backed by a derived, always-present "scope" field (see PoliciesView): the owning company, or "Platform".
    title: "Scope",
    key: "scope",
    width: 192,
  },
];

const companyPoliciesQueryMappings: QueryFieldMapping[] = [
  { formField: "name" },
  { formField: "code" },
  {
    formField: "company",
    queryField: "companyUid",
    operation: QueryOperation.Equal,
    transform: comboboxValue,
  },
];

export const mapCompanyPoliciesViewQuery = (values: CompanyPoliciesViewForm): SearchQuery =>
  buildSearchQuery(values, companyPoliciesQueryMappings);
